import EnvHandler, { Environments as _Environments } from './env-handler-setup'

export const Environments = _Environments
export default { ...EnvHandler }
